import { AgGridReact } from "ag-grid-react";
import React, { createContext, useContext, useEffect, useRef } from "react";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { Observer, observer } from "mobx-react-lite";
import {
  Badge,
  Button,
  Divider,
  Empty,
  message,
  notification,
  Radio,
  Skeleton,
  Tooltip,
} from "antd";
import {
  ExclamationCircleOutlined,
  FileExcelOutlined,
  QuestionOutlined,
  UploadOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { NoData } from "../../../shared/NoData";
import moment from "moment";
import formatNumber from "accounting-js/lib/formatNumber.js";
import "../styles/naocdailyproduction.css";
import { CommandBar, SearchBox } from "@fluentui/react";
import {
  RefreshCcw,
  Edit3,
  Trash2,
  FileText,
  BarChart,
  BarChart2,
  FilePlus,
  FileMinus,
  Sliders,
  Monitor,
  Eye,
  ExternalLink,
  ZoomIn,
  Paperclip,
  CheckCircle,
  Layers,
} from "react-feather";
import { toJS } from "mobx";
import confirm from "antd/lib/modal/confirm";
import { FilterCallOut } from "../../../shared/FilterCallOut";
import PreferenceStore from "../../home/store/preferenceStore";
import ReportStore from "../../../shared/ReportStore";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import RequestStore from "../approvals/store/requeststore";
import { ToolBarMenuSeparator } from "../../../shared/ToolBarMenuSeparator";
import _ from "underscore";
const Preferencestore = createContext(PreferenceStore);
const reportStoreCtx = createContext(ReportStore);
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
const requestStoreCtx = createContext(RequestStore);
export const EbendoProductionGrid = observer((props) => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);
  const preferenceStore = useContext(Preferencestore);
  const reportStore = useContext(reportStoreCtx);
  const { fullName } = getCurrentUser();
  const prodGrid = useRef(null);
  const requestStore = useContext(requestStoreCtx);
  useEffect(() => {
    async function loadproductionHistory() {
      try {
        await ebendoDailyProductionStore.loadProductions();
        ebendoDailyProductionStore.resultFromQuery = false;
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadproductionHistory();
  }, [preferenceStore.preference]);
  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: preferenceStore.preference.oilValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const formatDigitGas = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: preferenceStore.preference.gasValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };
  const sortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,

        width: 80,
        pivot: false,
      },
      {
        width: 30,

        pivot: false,
        cellRenderer: (item) => {
          const antStatuses = ["default", "warning", "success", "error"];
          const submitStatuses = [
            "Not Submitted",
            "Awaiting-Approval",
            "Approved",
            "Declined",
          ];
          return (
            <div
              style={{ padding: "none!important" }}
              title={submitStatuses[item.data.approvalStatus]}
            >
              <Badge status={antStatuses[item.data.approvalStatus]} />
            </div>
          );
        },
      },

      {
        headerName: "EBENDO FIELD PRODUCTION",
        headerClass: "oilheader",
        children: [
          {
            headerName: "STATION OIL AND GAS PRODUCTION/DATA",
            children: [
              {
                headerName: "PDY",
                field: "pdYear",
                sortable: true,
                resizable: true,
                pivot: true,

                hide: true,
                width: 80,
              },
              {
                headerName: "PDYM",
                field: "pdYearMonth",
                sortable: true,
                resizable: true,
                hide: true,
                width: 100,
              },

              {
                width: 50,
                cellRenderer: (props) => {
                  return (
                    <Button
                      type="link"
                      title="show production entry details"
                      onClick={async () => {
                        try {
                          requestStore.showEbendoProductionDetailDialog = true;
                          await ebendoDailyProductionStore.getEbendoDailyProductionById(
                            props.data.ebendoDailyProductionId
                          );
                        } catch (error) {
                          notification.error({
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }

                        //requestStore.showCommentPane = true;
                      }}
                      icon={
                        <ExternalLink
                          size={16}
                          color="#1890ff"
                          style={{ marginRight: "5px", cursor: "pointer" }}
                        />
                      }
                    ></Button>
                  );
                },
              },
              {
                headerName: "Well Allocation",
                field: "productionDate",
                type: ["dateColumn", "nonEditableColumn"],
                sortable: true,
                resizable: true,
                width: 150,
                valueFormatter: (props) => {
                  return "Drill Down";
                },

                cellRenderer: "agGroupCellRenderer",
                cellStyle: { textAlign: "center", color: "red" },
              },
              {
                headerName: "Production Date",
                field: "productionDate",
                type: ["dateColumn", "nonEditableColumn"],
                sortable: true,
                resizable: true,
                width: 150,
                valueFormatter: (props) => {
                  if (!props.data?.productionDate) {
                    return "";
                  }

                  return moment(props.data?.productionDate).format(
                    preferenceStore.preference.dateFormat
                  );
                },
              },
              {
                headerName: "Station Downtime (hrs)",
                field: "stationDownHrs",
                width: 150,
                resizable: true,
                sortable: true,
                pivot: false,
              },
              {
                headerName: "Station °API @ 60",
                field: "stationAPI",
                width: 150,
                resizable: true,
                sortable: true,
                pivot: false,
              },
              {
                headerName: "(Bulk Liquid Prod)BLPD",
                field: "blpd",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Station BSW (%)",
                field: "bsw",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Net Production (bopd)",
                field: "oil",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "right", backgroundColor: "#ffcdd2" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Station Water Prod (bwpd)",
                field: "water",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },

              {
                headerName: "Station Gas Production (Mmscfd)",
                field: "gas",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitGas,
              },
              {
                headerName: "Fuel Gas(Consumed in Operation)  (Mmscfd)",
                field: "fuelGas",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "#B9F6CA",
                },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitGas,
              },
              {
                headerName: "Flare Gas (Mmscfd)",
                field: "flareGas",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitGas,
              },
              {
                headerName: "Condensate from Gas Plant (bopd) ",
                field: "condensate",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center", backgroundColor: "#FFC107" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Station Cumulative Gross Prod (bbls) ",
                field: "cumGrossProduction",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 190,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },

              {
                headerName: "Station Cumulative Net Oil Prod (bbls) ",
                field: "cumNetProduction",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 190,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Station Cumulative Gas Prod (Mmscf) ",
                field: "cumGasProduction",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 190,
                type: "numberColumn",
                valueFormatter: formatDigitGas,
              },
              {
                headerName: "Station Cumulative Water Production (bwpd)",
                field: "cumWaterProduction",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 190,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Station Cumulative Condensate (bbls) ",
                field: "cumCondProduction",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "rgb(204,218,236)",
                },
                width: 190,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
            ],
          },
          {
            headerName: "EVACUATIONS",
            children: [
              {
                headerName: "Crude Injection to GGF (bbls) ",
                field: "crudeInjectionGGF",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "#ef9a9a",
                },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Total Gas Supplied  To gas Plant (Mmscfd)",
                field: "gasSuppliedToGasPlant",
                sortable: true,
                resizable: true,
                cellStyle: {
                  textAlign: "right",
                  backgroundColor: "#C8E6C9",
                },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Evacuated Condensate",
                field: "evacuatedCondensate",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center", backgroundColor: "#FFECB3" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Ase River Crude Export  ",
                field: "aseRiverExport",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Ase River Daily Uptime (hrs)",
                field: "aseRiverUptime",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Forcados Crude Export ",
                field: "forcadosExport",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
              {
                headerName: "Forcados Daily Uptime (hrs) ",
                field: "forcadosUptime",
                sortable: true,
                resizable: true,
                cellStyle: { textAlign: "center" },
                width: 170,
                type: "numberColumn",
                valueFormatter: formatDigitOil,
              },
            ],
          },
          {
            headerName: "Remarks",
            field: "remarks",
            filter: true,
            sortable: true,
            resizable: true,
            cellRenderer: (item) => {
              if (!item.data) {
                return null;
              }

              return (
                item.data.remarks && (
                  <>
                    <span>
                      {" "}
                      <Button
                        type="link"
                        title="show field production remarks"
                        onClick={() => {
                          ebendoDailyProductionStore.remarkObj = {
                            title: ` ${moment(item.data?.productionDate).format(
                              preferenceStore.preference.dateFormat
                            )}  Field Production Remarks`,
                            remark: item.data.remarks,
                          };
                          ebendoDailyProductionStore.showRemarkPane = true;
                        }}
                        style={{ cursor: "pointer" }}
                        icon={<ExternalLink size={16} color="gray" />}
                      ></Button>
                    </span>
                    <span>
                      {item.data.remarks &&
                        item.data.remarks.replace(/(<([^>]+)>)/gi, " ")}
                    </span>
                  </>
                )
              );
            },
          },
          {
            headerName: "AUDIT",

            children: [
              {
                headerName: "Status",
                pivot: false,
                cellRenderer: (item) => {
                  const submitStatuses = [
                    "Not Submitted",
                    "Awaiting-Approval",
                    "Approved",
                    "Declined",
                  ];
                  return (
                    <div
                      style={{ padding: "none!important" }}
                      title={submitStatuses[item.data.approvalStatus]}
                    >
                      <span>{submitStatuses[item.data.approvalStatus]}</span>
                    </div>
                  );
                },
              },
              {
                headerName: "Uploaded(Modified) By",
                field: "uploadedBy",
                filter: true,
                sortable: true,
                resizable: true,
              },
              {
                headerName: "Uploaded On",
                field: "uploadedOn",
                sortable: true,
                resizable: true,
                filter: true,
                cellRenderer: function (props) {
                  return moment(props.data.uploadedOn).format(
                    "ddd DD.MM.YYYY , h:mm:ss a"
                  );
                },
              },
              {
                headerName: "Request Party",
                field: "requestor",
                filter: true,
                sortable: true,
                resizable: true,
              },
              {
                headerName: "Request Date",
                field: "",
                sortable: true,
                resizable: true,
                filter: true,
                cellRenderer: function (item) {
                  if (item.data?.requestDate) {
                    return (
                      <span
                        title={moment(item.data.requestDate).format("LLLL")}
                      >
                        {moment(item.data.requestDate).fromNow()}
                      </span>
                    );
                  } else {
                    return null;
                  }
                },
              },
              {
                headerName: "Approved Party",
                field: "",
                filter: true,
                sortable: true,
                resizable: true,
              },
              {
                headerName: "Approved Date",
                field: "",
                sortable: true,
                resizable: true,
                filter: true,
                /*  cellRenderer: function (props) {
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            }, */
              },
              {
                headerName: "Approver Remarkss",
                field: "",
                filter: true,
                sortable: true,
                resizable: true,
              },
            ],
          },
        ],
      },
    ],
  };
  const refreshData = async () => {
    try {
      let queryCriteria = {
        startDate: moment(new Date())
          .startOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        endDate: moment(new Date())
          .endOf("month")
          .format("YYYY-MM-DDT00:00:00.000Z"),
        fromInception: false,
        specificDate: false,
      };
      ebendoDailyProductionStore.queryCriteria = queryCriteria;
      await ebendoDailyProductionStore.loadProductions();
      ebendoDailyProductionStore.gridHeaderText = `EBENDO PRODUCTION from ${moment(
        queryCriteria.startDate
      ).format("ddd DD-MMM-YYYY")} to ${moment(queryCriteria.endDate).format(
        "ddd DD-MMM-YYYY"
      )}`;
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  };
  const refreshHandler = async () => {
    await refreshData();
  };
  const rowSelected = (grid) => {
    ebendoDailyProductionStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      ebendoDailyProductionStore.selRow = toJS(selrow.data);
    }
    requestStore.setProducingDays(_.pluck(grid.api.getSelectedNodes(), "data"));
    requestStore.productionGrid = grid;
  };
  const wellParaColumns = [
    {
      headerName: "#",
      valueGetter: "node.rowIndex + 1",
      width: 50,
      resizable: true,
      sortable: true,
      pivot: false,
      editable: false,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },

    {
      headerName: "Well",
      field: "wellName",
      sortable: true,
      resizable: true,
      editable: false,

      width: 150,
      pinnedRowCellRenderer: (props) => {
        return "Total Well Productions";
      },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
    },
    {
      headerName: "Status",
      field: "wellStatusDesc",
      editable: false,

      width: 100,
    },
    {
      headerName: "Well line up",
      field: "wellLineUp",
      width: 100,
      sortable: true,
      resizable: true,

      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: 'Choke X/64"',
      field: "choke",
      width: 100,
      sortable: true,
      resizable: true,
      pinnedRowCellRenderer: (props) => {
        return "";
      },
    },
    {
      headerName: "Hours Online",
      field: "hoursOnline",
      width: 100,
      sortable: true,
      resizable: true,
    },
    {
      headerName: "FTHP (psig)",
      field: "fthp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "WHT (°F)",
      field: "wht",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "FLP (psig)",
      field: "flp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "CHP  (psig)",
      field: "chp",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "BLPD",
      field: "blpd",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
      pinnedRowCellRendererParams: {
        style: { color: "red" },
      },
      pinnedRowCellRenderer: (props) => {
        return ebendoDailyProductionStore.totalBLPD;
      },
    },
    {
      headerName: "%BS&W",
      field: "bsw",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "OIL (BOPD)",
      field: "oil",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "WATER (BWPD)",
      field: "water",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GAS (MMSCF/D)",
      field: "gas",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GOR  (SCF/BBL)",
      field: "gor",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "GLR  (SCF/BBL)",
      field: "glr",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "API",
      field: "api",
      width: 100,
      sortable: true,
      resizable: true,
      type: "numberColumn",
      cellStyle: { textAlign: "right" },
    },
  ];

  const detailCellRendererParams = {
    detailGridOptions: {
      columnDefs: wellParaColumns,
    },
    getDetailRowData: async function (params) {
      try {
        if (!params.data?.productionDate) {
          params.successCallback([]);
          return;
        }

        const pdate = toJS(params.data?.productionDate);
        const wellContributions =
          await ebendoDailyProductionStore.getWellContributions(pdate);
        console.log(wellContributions);
        return await params.successCallback(wellContributions);
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    },
  };
  return (
    <>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Observer>{() => <CommandBar
            items={[
              {
                key: "filtert3t",
                onRenderIcon: () => <FilterCallOut />,
              },
              {
                key: "refresh",
                text: (
                  <Tooltip title="Refresh daily production data">
                    Refresh
                  </Tooltip>
                ),

                onRenderIcon: () => <RefreshCcw className="qicon" />,

                onClick: async () => {
                  await refreshData();
                },
              },
              {
                key: "modify",
                text: (
                  <Tooltip title="Modify or edit selected daily production figures">
                    Modify
                  </Tooltip>
                ),
                disabled:
                  requestStore.producingDays.length !== 1 ||
                  ebendoDailyProductionStore.selRow.approvalStatus === 2,
                onRenderIcon: () => <Edit3 className="qicon" />,

                onClick: async () => {
                  if (ebendoDailyProductionStore.selRow) {
                    ebendoDailyProductionStore.initFormaData =
                      ebendoDailyProductionStore.selRow;
                    const retval =
                      await ebendoDailyProductionStore.getWellContributions(
                        ebendoDailyProductionStore.selRow.productionDate
                      );

                    retval.forEach((para) => {
                      ebendoDailyProductionStore.wellparameters.set(
                        para.ebendoDailyProductionWellId,
                        para
                      );
                    });

                    ebendoDailyProductionStore.view = "manual";
                    ebendoDailyProductionStore.uploadDate = moment(
                      ebendoDailyProductionStore.selRow.productionDate
                    );
                    ebendoDailyProductionStore.showEbendoDailyProductionDialog = true;
                  }
                },
              },

              {
                key: "remove",
                text: (
                  <Tooltip title="Remove or delete selected daily production data with action logged ">
                    Remove
                  </Tooltip>
                ),
                name: "delete",
                disabled:
                  requestStore.producingDays.length !== 1 ||
                  !_.contains(
                    [0, 3],
                    ebendoDailyProductionStore.selRow.approvalStatus
                  ),

                // disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <Trash2 className="qicon" />,
                onClick: () => {
                  const seldata = prodGrid.current.api.getSelectedNodes()[0];
                  console.log(seldata);

                  if (!seldata) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select production data row to remove",
                    });
                    return;
                  }

                  confirm({
                    icon: <QuestionOutlined />,
                    title: "Delete production",
                    content: (
                      <div
                        className="ms-Grid"
                        dir="ltr"
                        style={{ padding: "10px" }}
                      >
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            Confirm removal of production data
                          </div>
                        </div>
                        <div className="ms-Grid-row">
                          <div
                            className="ms-Grid-col ms-sm12"
                            style={{ fontStyle: "italic", padding: "10px" }}
                          >
                            <ExclamationCircleOutlined
                              style={{ color: "red" }}
                            />{" "}
                            this operation will be logged
                          </div>
                        </div>
                      </div>
                    ),
                    onOk: async () => {
                      try {
                        const seldata =
                          prodGrid.current.api.getSelectedNodes()[0];
                        const { ebendoDailyProductionId, productionDate } =
                          seldata.data;

                        if (ebendoDailyProductionId) {
                          const retVal =
                            await ebendoDailyProductionStore.deleteProduction(
                              ebendoDailyProductionId,
                              productionDate
                            );
                          if (retVal.success) {
                            ebendoDailyProductionStore.dailyProductions.delete(
                              retVal.prodId
                            );
                            message.success(
                              "Production record deleted successfully"
                            );
                          }
                        }
                      } catch (error) {
                        notification.error({
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                    onCancel() {
                      console.log("Cancel");
                    },
                  });
                },
              },
              {
                key: "spacere",
                onRender: () => <div style={{ width: "50px" }} />,
              },
              {
                key: "access",

                text: (
                  <Tooltip title="perform quick query on daily production using production dates">
                    Prod.Date Query
                  </Tooltip>
                ),

                onRenderIcon: () => <ZoomIn className="qicon" />,

                onClick: () => {
                  ebendoDailyProductionStore.showSQeryDialog = true;
                },
              },

              {
                key: "fisc",
                onRender: () => (
                  <Tooltip title="view  production data as JV Gross (no equity factor applied) or OANDO equity share (with equity factor applied)">
                    <div
                      className="ms-Grid"
                      dir="ltr"
                      style={{ paddingTop: "10px" }}
                    >
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm1"
                          style={{ textAlign: "center" }}
                        >
                          <div
                            style={{
                              display: "inline-block",
                              marginTop: "5px",
                            }}
                          >
                            <Eye className="qicon" />
                          </div>{" "}
                        </div>
                        <div className="ms-Grid-col ms-sm11">
                          {" "}
                          <Observer>
                            {() => (
                              <Radio.Group
                                buttonStyle="solid"
                                size="small"
                                value={
                                  ebendoDailyProductionStore.productionview
                                }
                                onChange={async ({ target }) => {
                                  try {
                                    ebendoDailyProductionStore.productionview =
                                      target.value;
                                    if (target.value === "gross") {
                                      ebendoDailyProductionStore.gridHeaderText = `${ebendoDailyProductionStore.gridHeaderText.replace(
                                        "OANDO Share",
                                        "EBENDO JV(Gross)"
                                      )} `;
                                      ebendoDailyProductionStore.IsEquityProduction = 0;
                                    } else {
                                      ebendoDailyProductionStore.gridHeaderText = `${ebendoDailyProductionStore.gridHeaderText.replace(
                                        "EBENDO JV(Gross)",
                                        "OANDO Share"
                                      )}`;
                                      ebendoDailyProductionStore.IsEquityProduction = 1;
                                    }
                                    await ebendoDailyProductionStore.loadProductions();
                                  } catch (error) {
                                    notification.error({
                                      message: "SPARS Feedback",
                                      description: error.message,
                                    });
                                  }
                                }}
                              >
                                <Radio.Button value="gross">
                                  EBENDO JV Gross
                                </Radio.Button>
                                <Radio.Button value="oando">
                                  OANDO Share
                                </Radio.Button>
                              </Radio.Group>
                            )}
                          </Observer>
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                ),

                name: "access",

                onRenderIcon: () => <Sliders className="qicon" />,
                onClick: () => {
                  //prodGrid.current.api.showNoRowsOverlay()
                },
              },
              {
                key: "spacer3",
                onRender: () => <div style={{ width: "50px" }} />,
              },

              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        prodGrid.current.api.setQuickFilter(searchTerms);
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
              {
                key: "request",
                text: "Request Sign-Off",
                buttonStyles: { root: { color: "#1890ff" } },
                onRenderIcon: () => <CheckCircle className="qicon" size={32} />,
                disabled:
                  [...requestStore.producingDays.values()].length === 0 ||
                  !_.every(
                    _.pluck(requestStore.producingDays, "approvalStatus"),
                    (x) => _.contains([0, 3], x)
                  ),
                onClick: () => {
                  requestStore.showRequestDialog = true;
                  console.log(
                    "sttus",
                    _.every(
                      _.pluck(requestStore.producingDays, "approvalStatus"),
                      (x) => _.contains([0, 3], x)
                    )
                  );
                },
              },
            ]}
            farItems={[
              {
                key: "Qr1",
                onClick: () => {
                  reportStore.reportName =
                    "QikReach.Reporting.Ebendo.EbendoJVDailyProduction,QikReach.Reporting";
                  reportStore.showReportDialog = true;
                },
                text: (
                  <Tooltip title="generate quick EBENDO daily production reports">
                    Reports
                  </Tooltip>
                ),

                onRenderIcon: () => <FileText className="qicon" />,

                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "sep42",
                      onRender: () => (
                        <Divider>Flash Production Reports</Divider>
                      ),
                    },
                    {
                      key: "emailMessage",
                      text: "EBENDO Field JV(Gross) Production Report",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <FilePlus className="qicon" />,
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdStart: moment(new Date())
                            .startOf("month")
                            .format("YYYY-MM-DDT00:00:00.000Z"),
                          ProdEndDate: moment(new Date())
                            .endOf("month")
                            .format("YYYY-MM-DDT00:00:00.000Z"),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Ebendo.EbendoJVDailyProduction,QikReach.Reporting";
                        reportStore.headerText =
                          "EBENDO Field JV(Gross)  production";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "calendarEvent",
                      text: "EBENDO-OANDO SHARE  Report",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <FileMinus className="qicon" />,
                      onClick: () => {
                        reportStore.reportParameters = {
                          ProdStart: moment(new Date())
                            .startOf("month")
                            .toDate(),
                          ProdEndDate: moment(new Date())
                            .endOf("month")
                            .toDate(),
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Ebendo.EbendoEquityDailyProduction,QikReach.Reporting";
                        reportStore.headerText =
                          "EBENDO-OANDO SHARE production";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "sep46",
                      onRender: () => <Divider>OER Summary Reports</Divider>,
                    },
                    {
                      key: "oer",

                      text: (
                        <Tooltip title="OER Provisional Report">
                          OER Provisional EBENDO JV Daily Production
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Paperclip className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (ebendoDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            ebendoDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }
                        reportStore.reportParameters = {
                          ProdDate: reportDate,
                          PreparedBy: fullName,
                        };

                        reportStore.reportName =
                          "QikReach.Reporting.Ebendo.EbendoOERReport,QikReach.Reporting";
                        reportStore.headerText =
                          "OER Provisional EBENDO JV Daily Production";
                        reportStore.showReportDialog = true;
                      },
                    },

                    {
                      key: "oerunrec",

                      text: (
                        <Tooltip title="OER Unreconciled Consolidated Evacuation Summary">
                          OER Unreconciled Consolidated Evacuation Summary
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Monitor className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (ebendoDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            ebendoDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }
                        reportStore.reportParameters = {
                          ProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Ebendo.EbendoOERUnReconciledReport,QikReach.Reporting";
                        reportStore.headerText =
                          "OER Unreconciled Consolidated Evacuation Summary";
                        reportStore.showReportDialog = true;
                      },
                    },
                    {
                      key: "sep1",
                      onRender: () => <ToolBarMenuSeparator />,
                    },

                    {
                      key: "integrated",

                      text: (
                        <Tooltip title="OER Provisional Report">
                          Daily Integrated Performance
                        </Tooltip>
                      ),
                      onRenderIcon: () => <Layers className="qicon" />,

                      onClick: () => {
                        let reportDate = null;
                        if (ebendoDailyProductionStore.selRow.productionDate) {
                          reportDate = moment(
                            ebendoDailyProductionStore.selRow.productionDate
                          ).add(1, "days");
                          console.log(reportDate);
                        }

                        reportStore.reportParameters = {
                          NaocProdDate: reportDate,
                          PreparedBy: fullName,
                        };
                        reportStore.reportName =
                          "QikReach.Reporting.Naoc.OERIntegrated,QikReach.Reporting";
                        reportStore.headerText = "Daily Integrated Performance";
                        reportStore.showReportDialog = true;
                      },
                    },
                  ],
                },
              },
              {
                key: "Qr",
                disabled:
                  ebendoDailyProductionStore.dailyProductions.size === 0,

                onRenderIcon: () => <BarChart2 className="qicon" />,
                text: (
                  <Tooltip title="generate quick visualization for EBENDO Daily Production and Evacuation Rythm">
                    Quick Viz.
                  </Tooltip>
                ),
                ariaLabel: "New",
                subMenuProps: {
                  items: [
                    {
                      key: "dopl1",
                      text: "Daily Production and Evacuation Rythm",
                      iconProps: { iconName: "" },
                      onRenderIcon: () => <BarChart className="qicon" />,
                      onClick: () => {
                        ebendoDailyProductionStore.showEbendoRythmDrawer = true;
                      },
                    },
                  ],
                },
              },
              {
                key: "group4",
              
                text: (
                  <Tooltip title="Export displayed production data to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                subMenuProps: {
                  items: [
                    {
                      key: "exportd1",
                      text: (
                        <Tooltip title="Export  ebendo  well allocations data to excel">
                          Export Productions with Well allocated Volumes to
                          Excel
                        </Tooltip>
                      ),
                      iconProps: { iconName: "" },

                      onClick: () => {
                        ebendoDailyProductionStore.exportOnlyWellAllocationVolume = false;
                        ebendoDailyProductionStore.showWellAllocationExportDialog = true;
                      },
                    },
                    {
                      key: "exportd11",
                      text: (
                        <Tooltip title="Export displayed quaibo  well allocations data to excel">
                          Export Well allocated Volumes to Excel
                        </Tooltip>
                      ),
                      iconProps: { iconName: "" },

                      onClick: () => {
                        ebendoDailyProductionStore.exportOnlyWellAllocationVolume = true;
                        ebendoDailyProductionStore.showWellAllocationExportDialog = true;
                      },
                    },
                    {
                      key: "sep47",
                      onRender: () => <Divider>Table Export</Divider>,
                    },
                    {
                      text: (
                        <Tooltip title="Export displayed production without respective well allocation data to excel">
                          Export Productions displayed in Table
                        </Tooltip>
                      ),
                      name: "group",

                      onClick: async () => {
                        try {
                          ebendoDailyProductionStore.isExporting = true;
                          await prodGrid.current.api.exportDataAsExcel({
                            sheetName:
                              ebendoDailyProductionStore.gridHeaderText.replace(
                                "EBENDO PRODUCTION",
                                "EBENDO"
                              ),

                            allColumns: true,
                            columnGroups: true,
                            skipFooters: false,
                            skipGroups: false,
                            skipHeader: false,
                            skipPinnedTop: false,
                            skipPinnedBottom: false,
                            fileName: "ebendo_daily_production_data",
                            skipColumnGroupHeaders: false,
                            skipColumnHeaders: false,
                          });
                        } catch (error) {
                          notification.error({
                            message: "SPARS Feedback",
                            description: "export failed",
                          });
                        } finally {
                          ebendoDailyProductionStore.isExporting = false;
                        }
                      },
                    },
                  ],
                },
              },
            ]}
          />}</Observer>
        </div>
      </div>

      {ebendoDailyProductionStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
          className="ag-theme-balham qikreach-grid-fill"
          style={{
            minHeight: "50vh",
            height: "65vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {ebendoDailyProductionStore.dailyProductions.size > 0 ? (
            <AgGridReact
              rowData={[
                ...ebendoDailyProductionStore.dailyProductions.values(),
              ]}
              sideBar={["columns", "filters"]}
              ref={prodGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              rowSelection={{
                mode: "multiRow",
                checkboxes: true,
                headerCheckbox: true,
                enableClickSelection: true,
                enableSelectionWithoutKeys: true,
              }}
              selectionColumnDef={{
                width: 30,
                resizable: false,
                sortable: false,
                suppressHeaderMenuButton: true,
              }}
              rowMultiSelectWithClick={true}
              onSelectionChanged={rowSelected}
              onSortChanged={sortChanged}
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          ) : ebendoDailyProductionStore.dailyProductions.size === 0 &&
            ebendoDailyProductionStore.resultFromQuery === false ? (
            <div className="ms-Grid" dir="ltr" style={{}}>
              <div className="ms-Grid-row">
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{
                    height: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Empty
                    description={`No Productions Upload for  ${moment(
                      ebendoDailyProductionStore.queryCriteria.startDate
                    ).format("MMM YYYY")}`}
                  />
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "20px" }}
                    >
                      {" "}
                      <Button
                        type="danger"
                        icon={<UploadOutlined />}
                        onClick={() => {
                          ebendoDailyProductionStore.showEbendoDailyProductionDialog = true;
                        }}
                      >
                        Start EBENDO Production & Evacuation Upload
                      </Button>
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      OR
                    </div>
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{ textAlign: "center", paddingTop: "10px" }}
                    >
                      <Button
                        type="link"
                        icon={<ZoomInOutlined />}
                        onClick={() => {
                          ebendoDailyProductionStore.showSQeryDialog = true;
                        }}
                      >
                        View previous naoc daily production upload
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <NoData
              title="No Production Record Found"
              subTitle="Sorry, No EBENDO field production record match for the selected production date"
              clickHandler={refreshHandler}
            />
          )}
        </div>
      )}
    </>
  );
});

